import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntitySidebar from 'components/EntitySidebar';
import SidebarBox from 'components/SidebarBox';

import { HotelSidebar_hotel$key } from '__generated__/HotelSidebar_hotel.graphql';

type Props = {
  hotel: HotelSidebar_hotel$key;
};

const HotelSidebar: FC<Props> = props => {
  const hotel = useFragment(
    graphql`
      fragment HotelSidebar_hotel on Hotel {
        source

        ...EntitySidebar_entity
      }
    `,
    props.hotel
  );

  return (
    <EntitySidebar entity={hotel}>
      <SidebarBox label="Šaltinis">{hotel.source}</SidebarBox>
    </EntitySidebar>
  );
};

export default HotelSidebar;
